import { requestWithToken } from '../utilities/request';

const list = (field_id, params) => {
  return requestWithToken({
    method: 'GET',
    url: `/api/private/fields/${field_id}/ky_work_finish_reports/list`,
    params,
  });
};

const bulkUpdateStatus = (field_id, params) => {
  return requestWithToken({
    method: 'PATCH',
    url: `/api/private/fields/${field_id}/ky_work_finish_reports/bulk_update_status`,
    data: params,
  });
};

const detail = (field_id, id) => {
  return requestWithToken({
    method: 'GET',
    url: `/api/private/fields/${field_id}/ky_work_finish_reports/${id}`,
  });
};

export const KyWorkFinishReportService = {
  list,
  bulkUpdateStatus,
  detail,
};

export default KyWorkFinishReportService;



// WEBPACK FOOTER //
// ./src/services/KyWorkFinishReports.js